<template>
  <v-checkbox
    :input-value="agreeTermsConditions"
    class="ma-0 pa-0"
    color="blue"
    @change="change">
    <template #label>
      <div>
        I agree with
        <a
          class="blue--text"
          href="https://gosourcery.com/terms-conditions"
          target="_blank"
          @click.stop>
          the terms and conditions
        </a>
      </div>
    </template>
  </v-checkbox>
</template>
<script>
export default {
  name: 'SignUpAgreeTermsConditions',
  props: {
    agreeTermsConditions: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    change(val) {
      this.$emit('update:agreeTermsConditions', val);
    },
  },
};
</script>
<style scoped lang="scss"></style>
